// utilities
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatDate, getCurrentDate } from "../utils";
// components
import { Typography } from ".";
import { useMemo } from "react";
export default function Footer({ config = {}, visible = true, showDisclaimer = false }) {
    const { report_name = "", company = "", disclaimer, copyright, pageNumber = 0 } = config;
    const date = useMemo(()=>formatDate(getCurrentDate()), []);
    const left = copyright || company || date;
    const middle = {
        top: report_name || company && !copyright,
        bottom: (company || copyright) && date || ""
    };
    const right = `Page | ${pageNumber}`;
    if (!visible) return /*#__PURE__*/ _jsx("div", {});
    return /*#__PURE__*/ _jsxs("div", {
        style: styles.container,
        children: [
            showDisclaimer && disclaimer,
            /*#__PURE__*/ _jsxs("div", {
                style: styles.grid,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: styles.left,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "caption",
                            children: left
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        id: "footerContainerMiddle",
                        style: styles.middle,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                children: middle.top
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "caption",
                                children: middle.bottom
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: styles.right,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "caption",
                            children: right
                        })
                    })
                ]
            })
        ]
    });
}
const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "16px 0",
        minHeight: "50px",
        borderTop: "1px solid #dcdcdc",
        backgroundColor: "white"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)"
    },
    left: {
        display: "flex",
        alignItems: "start"
    },
    middle: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0
    },
    right: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end"
    }
};
